import React, { useEffect } from "react";

import { browserHistory } from 'react-router';
import { isAgentUser } from "./utils";

const StatsOrListingWrapper = () => {
  const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");

  const isUserRestricted = isAgentUser(storedUserData);
  useEffect(() => {
    // if (isUserRestricted) {
    //    const baseUrl = location.origin;
    //   const url = `${baseUrl}/${"list?source=STRIVE&status=Active&transaction_type=Investment+Sales"}`;
    //   window.location.href = url;
    // } else {
    //    const baseUrl = location.origin;
    //     const url = `${baseUrl}/${"stats"}`;
    //   window.location.href = url;
    // }
    if (isUserRestricted) {
  browserHistory.push('/proeprty');
} else {
  browserHistory.push('/stats');
  // or whatever the path should be
}
  }, [isUserRestricted]);
  return null
};

export default StatsOrListingWrapper;
